'use client'

import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

import { DetailPageHeader } from '@/components/header/detail-page-header'

import { AddToCanvasButton } from './add-to-canvas-button'
import { VisibilityToggleBadge } from './visibility-toggle-badge'

export function TemplateHeaderInjector({
  title,
  emailId,
  orgId,
  visibility,
  activeBrandId,
}: {
  title: string
  emailId: string
  orgId?: string
  visibility: string
  activeBrandId?: string
}) {
  const t = useTranslations('templates')
  const rightContent = useMemo(
    () => (
      <div className="flex items-center gap-1">
        {orgId === 'forwarded' ? (
          <AddToCanvasButton emailId={emailId} brandId={activeBrandId} />
        ) : null}
        <VisibilityToggleBadge
          emailId={emailId}
          currentVisibility={visibility}
        />
      </div>
    ),
    [emailId, orgId, activeBrandId, visibility]
  )

  return (
    <DetailPageHeader
      parentLabel={t('title')}
      parentHref="/templates"
      title={title}
      actions={rightContent}
    />
  )
}
